module.exports = __webpack_public_path__ + "img/photo-0024.db046167.jpg";